import { ANALYTICS_EVENTS } from '../../events'
import createAnalyticsStatic, { EventProps } from '../createAnalyticsEvent'

export interface EthicalFilterSelectedProps extends EventProps {
    positive_filter: string
    negative_filter: string
}

/**
 * @event ethical_filter_selected
 * @description Emitted when the user finishes selecting ethical filters (positive/negative) and closes the select.
 */
export const EthicalFilterSelectedAnalytics = createAnalyticsStatic<EthicalFilterSelectedProps>(
    ANALYTICS_EVENTS.FIND_STOCKS.ETHICAL_FILTER_SELECTED,
)

export default EthicalFilterSelectedAnalytics
